import { useTranslation } from "react-i18next";

// Skip link ("saltar al contenido principal") — hallazgo transversal H10/H-06/
// H-08/H-12 de la auditoría UX/UI (oficina-tah/tareas/task-reparacion-marca-skip-link/
// tarea.md). Invisible salvo al recibir foco de teclado (patrón sr-only →
// focus:not-sr-only): el primer Tab de cualquier página pública lo revela por
// encima de todo (z-[100]) y salta directamente al <main id="main-content">
// de la página activa, saltándose la cabecera/nav.
//
// Reutiliza .btn-primary tal cual (AA-verificado en los 2 temas, con su propio
// anillo de foco, PR #355) — sin clase ni cálculo de contraste nuevo.
//
// `focus:px-5 focus:py-3 focus:whitespace-nowrap` NO son decorado: la utilidad
// `not-sr-only` de Tailwind incluye `padding: 0` y `white-space: normal`, que
// pisan el `px-5 py-3` de .btn-primary (@layer components se emite antes que
// utilities) y dejaban el enlace visible como una caja de 137x20 px con el
// texto pegado a los bordes — medido en navegador, no deducido. Con ellas
// recupera el tamaño real de .btn-primary (criterio 1: ".btn-primary íntegro").
export default function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main-content"
      className="btn-primary sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:whitespace-nowrap focus:px-5 focus:py-3"
      data-testid="skip-link"
    >
      {t("common.skipToContent")}
    </a>
  );
}
